module.exports = new __parcel__URL__("machines_photon_shield_level_3.c8303be2.png").toString();